<template>
  <vwc-badge :id="id" :connotation="connotation" :shape="shape" :translucent="shape" :outlined="outlined" :layout="layout">
    <slot></slot>
  </vwc-badge>
</template>

<script>
  import '@vonage/vwc-badge';

  export default {
    name: 'CdBadge',
    // See description at https://vivid.vonage.com/?path=/story/atoms-badge--basic
    props: {
      id: {
        type: String,
        default: '',
      },
      connotation: {
        type: String,
        default: 'cta',
      },
      shape: {
        type: String,
        default: 'rounded',
      },
      translucent: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      layout: {
        type: String,
        default: 'soft'
      }
    },
  };
</script>
